<template>
	<div id="NoAuthPage">
		无权限
	</div>
</template>
